import { render, staticRenderFns } from "./StatusInfo.vue?vue&type=template&id=809ae964&scoped=true&"
import script from "./StatusInfo.vue?vue&type=script&lang=js&"
export * from "./StatusInfo.vue?vue&type=script&lang=js&"
import style0 from "./StatusInfo.vue?vue&type=style&index=0&id=809ae964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809ae964",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('809ae964')) {
      api.createRecord('809ae964', component.options)
    } else {
      api.reload('809ae964', component.options)
    }
    module.hot.accept("./StatusInfo.vue?vue&type=template&id=809ae964&scoped=true&", function () {
      api.rerender('809ae964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/StatusInfo.vue"
export default component.exports